module.exports = __webpack_public_path__ + "img/left.75f97d66.jpg";